import React, { useState, useRef, useEffect } from 'react';

const DevToggleWrapper = ({ children }) => {
    const [devMode, setDevMode] = useState(() => {
        const storedMode = localStorage.getItem('imageHubDevMode');
        return storedMode === 'true';
    });
    const clickCountRef = useRef(0);
    const lastClickTimeRef = useRef(Date.now());

    const handleClick = () => {
        const now = Date.now();
        const timeSinceLastClick = now - lastClickTimeRef.current;

        if (timeSinceLastClick < 500) {
            clickCountRef.current += 1;
        } else {
            clickCountRef.current = 1;
        }

        lastClickTimeRef.current = now;

        if (clickCountRef.current >= 10) {
            const newMode = !devMode;
            setDevMode(newMode);
            localStorage.setItem('imageHubDevMode', newMode);
            clickCountRef.current = 0;
        }
    };

    const badgeStyle = {
        position: 'absolute',
        top: '16px',
        right: '16px',
        backgroundColor: '#f87171',
        color: '#ffffff',
        borderRadius: '16px',
        padding: '8px 16px',
        fontWeight: 'bold',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        opacity: devMode ? 1 : 0,
        transition: 'opacity 300ms ease-in-out',
        pointerEvents: 'none'
    };

    return (
        <div onClick={handleClick} style={{ position: 'relative', width: '100%', height: '100%' }}>
            {children}
            {devMode && <div style={badgeStyle}>DEV</div>}
        </div>
    );
};

export default DevToggleWrapper;
